export default __webpack_public_path__ + "static/media/831.cb889853.gif";